/**
 * Content category taxonomy. Single-select per content. Keys MUST stay in
 * lockstep with the enum on `SumadhuraCms.category` in the backend schema
 * (sumadhura.cms.schema.js). Display labels and colors are dashboard-only.
 *
 * Driven by:
 *   - WebsiteContentUploader.jsx (upload + edit modal dropdown)
 *   - MediaGrid.jsx (color chip on each card)
 *   - MediaV2Shell.jsx (filter dropdown + bulk-assign action)
 *   - future analytics page (brand-mix donut)
 */

export const CONTENT_CATEGORIES = [
  { key: 'Brand', label: 'Brand', color: '#4f46e5' },
  { key: 'Campaign', label: 'Campaign', color: '#c8a147' },
  { key: 'Project', label: 'Project', color: '#2da06b' },
  { key: 'ChannelPartner', label: 'Channel Partner', color: '#8b5cf6' },
  { key: 'ExistingCustomers', label: 'Existing Customers', color: '#0ea5b7' },
];

export const CATEGORY_KEYS = CONTENT_CATEGORIES.map((c) => c.key);

export const getCategory = (key) =>
  CONTENT_CATEGORIES.find((c) => c.key === key) || null;

export const getCategoryLabel = (key) => getCategory(key)?.label || '';

export const getCategoryColor = (key) => getCategory(key)?.color || '#9ca3af';
